import { RouteRecordRaw } from 'vue-router'

import { FLOOR_PLAN_ROUTE_NAMES } from '@/modules/floorplan/constants/FloorPlanRouteNames'

import { UserGroup } from '@generated/types'

export const floorPlanRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/floorplans',
    component: () => import('@/modules/floorplan/layouts/FloorPlanLayout.vue'),
    props: route => ({ floorPlanId: +route.params.floorPlanId || undefined }),
    meta: { requiresAuth: UserGroup.MANAGERS },
    children: [
      {
        path: '',
        name: FLOOR_PLAN_ROUTE_NAMES.LIST,
        component: () => import('@/modules/floorplan/pages/FloorPlanList.vue'),
        meta: { pageTitle: 'Floor Plans' },
      },
      {
        path: 'create',
        name: FLOOR_PLAN_ROUTE_NAMES.CREATE,
        component: () => import('@/modules/floorplan/pages/FloorPlanCreate.vue'),
        meta: { pageTitle: 'Floor Plan - Create' },
      },
      {
        path: ':floorPlanId/',
        children: [
          { path: '', redirect: { name: FLOOR_PLAN_ROUTE_NAMES.TABLE_LIST } },
          {
            path: 'tables',
            children: [
              {
                path: '',
                name: FLOOR_PLAN_ROUTE_NAMES.TABLE_LIST,
                component: () => import('@/modules/floorplan/pages/FloorPlanTableList.vue'),
                props: route => ({ floorPlanId: +route.params.floorPlanId }),
                meta: { pageTitle: 'Floor Plan - Tables' },
              },
              {
                path: ':tableIds+',
                name: FLOOR_PLAN_ROUTE_NAMES.TABLE_EDIT,
                component: () => import('@/modules/floorplan/pages/FloorPlanTableEdit.vue'),
                props: route => {
                  const tableIds: Array<number | string> = (route.params.tableIds as string[]).map(
                    id => (isNaN(Number(id)) ? id : Number(id)),
                  )
                  return { tableIds }
                },
                meta: { pageTitle: 'Floor Plan - Table Detail' },
              },
            ],
          },
          {
            path: 'pricing-tiers',
            name: FLOOR_PLAN_ROUTE_NAMES.PRICING_TIERS,
            component: () => import('@/modules/floorplan/pages/FloorPlanPricingTiers.vue'),
            meta: { pageTitle: 'Floor Plan - Pricing Tiers' },
          },
        ],
      },
    ],
  },
]
